









































































































import { mapActions, mapGetters } from 'vuex';
import { setErrorFromAxiosError } from '@/utils/helpers';

import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';

import { IWorkflow, WorkflowStateEnum } from '@/models';
import { ISystemError } from '@/models/error/error.types';

import ALPage from '@/components/core/Page/ALPage.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import WorkflowFormDialog from '@/components/workflows/WorkflowFormDialog.vue';

import WorkflowDetail from '@/components/workflows/WorkflowDetail.vue';
import { AxiosError } from 'axios';

const baseMixins = mixins(auth);

interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    workflowFormDialog: InstanceType<typeof WorkflowFormDialog>;
  };
}

export default baseMixins
  .extend<Options>({ functional: false })
  .extend({
    name: 'WorkflowDetailPage',

    components: {
      ALPage,
      ErrorAlert,
      WorkflowFormDialog,
      WorkflowDetail
    },

    data() {
      return {
        error: null as null | ISystemError,
        isLoading: false,
        isSetStateLoading: false,
        WorkflowStateEnum
      };
    },

    computed: {
      ...mapGetters({
        getWorkflowById: 'workflow/getWorkflowById',
        getWorkflowStateVisualByState: 'workflow/getWorkflowStateVisualByState'
      }),

      workflowId(): number {
        return Number(this.$route.params.id);
      },

      workflow(): IWorkflow {
        return this.getWorkflowById(Number(this.workflowId));
      }
    },

    async mounted() {
      this.isLoading = true;

      try {
        const workflow = await this.tryGetOrFetchWorkflow(this.workflowId);
        await Promise.all([
          // Expect workflow to exist. If no workflow then error has already occurred
          this.fetchWorkflowStates(workflow!.id),
          this.fetchWorkflowTransitions(workflow!.id)
        ]);
      } catch (err) {
        const error = err as AxiosError;
        this.error = setErrorFromAxiosError(error);
      } finally {
        this.isLoading = false;
      }
    },

    methods: {
      ...mapActions({
        fetchWorkflow: 'workflow/fetchWorkflow',
        fetchWorkflowStates: 'workflow/fetchWorkflowStates',
        fetchWorkflowTransitions: 'workflow/fetchWorkflowTransitions',
        setWorkflowState: 'workflow/setWorkflowState'
      }),

      async tryGetOrFetchWorkflow(
        workflowId: number
      ): Promise<IWorkflow | undefined> {
        if (!this.getWorkflowById(workflowId)) {
          await this.fetchWorkflow(workflowId);
        }

        return this.getWorkflowById(workflowId);
      },

      updateWorkflowState(state: WorkflowStateEnum) {
        this.clearError();
        this.isSetStateLoading = true;

        this.setWorkflowState({
          workflowId: this.workflowId,
          state: state
        })
          .catch(error => {
            this.error = setErrorFromAxiosError(error);
          })
          .finally(() => {
            this.isSetStateLoading = false;
          });
      },

      clearError() {
        this.error = null;
      },

      openWorkflowFormDialog() {
        return this.$refs.workflowFormDialog.open(this.workflow);
      }
    }
  });
